'use client';

import { useState } from 'react';

import { analytics } from '@kit/analytics';

import type { HelpUiLabels } from '~/(marketing)/hilfe/_lib/help-labels';

/**
 * „War das hilfreich?" – feuert ein consent-gated PostHog-Event über den
 * `@kit/analytics`-Singleton (dieselbe Pipeline, über die #421 nachweislich
 * Marketing-Events sendet). Kein PostHogProvider/`usePostHog` im Marketing.
 * Vor Consent → NullService (verworfen, TDDDG-konform).
 */
export function ArticleFeedback({
  slug,
  labels,
}: {
  slug: string;
  labels: HelpUiLabels;
}) {
  const [done, setDone] = useState(false);

  const vote = (helpful: boolean) => {
    void analytics.trackEvent('help_article_feedback', {
      slug,
      helpful: String(helpful),
    });
    setDone(true);
  };

  if (done) {
    return <p className="help-feedback-thanks">{labels.feedbackThanks}</p>;
  }

  return (
    <div className="help-feedback">
      <span className="help-feedback-q">{labels.feedbackQuestion}</span>
      <div className="help-feedback-btns">
        <button type="button" onClick={() => vote(true)}>
          {labels.feedbackYes}
        </button>
        <button type="button" onClick={() => vote(false)}>
          {labels.feedbackNo}
        </button>
      </div>
    </div>
  );
}
